import {style} from "typestyle";
import * as React from "react";
import {aroundJustified, endJustified, horizontal, horizontallySpaced, vertical, verticallySpaced} from "csstips";
import {ButtonPill} from "./button-pill";
import {Modal, ModalChildStyle} from "./modal";
import {em, important, percent, px, rem, viewWidth} from "csx";
import {colorBlack, colorBrand, colorContrast, colorSlate, colorSubtle, colorWhite} from "../theme/color";
import {shadowSubtle} from "../theme/shadow";
import {zToolip} from "../theme/z";
import {mediaMobileOnly, mediaTablet} from "../theme/media";

export default class ModalScreen extends React.Component<any, any> {

    buttons() {
        if (this.props.hasPrev) {
            return <div className={ModalScreen.styles.buttons}>
                <ButtonPill onClick={() => this.props.handlePrev()} muted>
                    Back
                </ButtonPill>
                {this.props.buttons}
                <ButtonPill onClick={() => this.props.handleClose()} muted>
                    Close
                </ButtonPill>
            </div>
        }

        if (this.props.hasNext) {
            return  <div className={ModalScreen.styles.buttons}>
            <ButtonPill onClick={() => this.props.handleClose()} muted>
                    Close
                </ButtonPill>
                {this.props.buttons}
                <ButtonPill onClick={() => this.props.handleNext()} muted>
                    Next
                </ButtonPill>
            </div>
        }
    }

    render() {
        return (
            <div>
                {this.props.children}
                {this.buttons()}
            </div>
        )
    }

    static styles = {
        buttons: style(
            mediaMobileOnly({
                ...vertical,
                ...verticallySpaced(10),
            }),{
                marginTop: rem(3),
                $nest: {
                    '& div': {
                        color: colorBrand.toString(),
                        paddingLeft: rem(3),
                        paddingRight: rem(3),
                    }
                }
            },
            mediaTablet({
                ...horizontal,
                ...horizontallySpaced(10),
                ...aroundJustified,

            })),
    };

}